import { Type } from 'class-transformer';
import { DimensionOptionResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-option-result-dto';

export class WFEBankAccountResultDto {
    bankAccountId: number;
    accountName: string;
    glAccountNumber: string;
    glAccountTitle: string;

    @Type(() => DimensionOptionResultDto)
    glDimensions: Array<DimensionOptionResultDto>;

    isAPDefault: boolean;

    get displayBankName(): string {
        return `${this.accountName}-${this.glAccountNumber}`;
    }
}
